import React from 'react';
export function PainSection() {
  return <section className="py-16 px-4 bg-white border-t border-gray-100" data-id="element-125">
      <div className="max-w-3xl mx-auto" data-id="element-126">
        <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-10 text-center leading-tight" data-id="element-127">
          💔 Mientras intentás educar con amor… terminás reaccionando como no
          querías
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed mb-12" data-id="element-128">
          <p data-id="element-129">
            😞 Hay momentos donde perdés la paciencia… y después viene la culpa
          </p>
          <p data-id="element-130">
            😔 Te prometés que no va a volver a pasar… pero en el próximo
            momento difícil, pasa de nuevo
          </p>
          <p data-id="element-131">💭 Sabés que querés hacerlo distinto… pero no sabés cómo</p>
          <p data-id="element-132">
            ⚠️ Y mientras tanto, la relación con tu hijo se llena de tensión,
            enojo y distancia
          </p>
        </div>

        <div className="bg-red-50 rounded-2xl p-8 md:p-10 my-12 border border-red-100 text-center" data-id="element-133">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-134">
            ❤️ No es que seas mala mamá
          </h3>
          <p className="text-xl text-gray-800 mb-6" data-id="element-135">
            Es que nadie te enseñó cómo manejar esos momentos
          </p>
          <p className="text-lg text-gray-700" data-id="element-136">
            No es falta de amor. No es falta de paciencia.
          </p>
          <p className="text-2xl font-bold text-red-600 mt-4" data-id="element-137">
            👉 Es falta de herramientas
          </p>
        </div>

        <div className="bg-slate-50 rounded-2xl p-8 md:p-10 my-12 border border-slate-200" data-id="element-138">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-139">
            🧠 Sin un método claro…
          </h3>
          <ul className="space-y-4 text-lg md:text-xl text-gray-700 max-w-md mx-auto mb-8" data-id="element-140">
            <li data-id="element-141">💔 seguís reaccionando en automático</li>
            <li data-id="element-142">💔 repitiendo patrones</li>
            <li data-id="element-143">💔 sintiéndote cada vez peor</li>
          </ul>
          <p className="text-xl font-bold text-center text-gray-900" data-id="element-144">
            Y eso no solo te afecta a vos… también afecta a tu hijo
          </p>
        </div>

        <div className="text-center my-12" data-id="element-145">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8" data-id="element-146">
            🔑 Lo que necesitás no es más información
          </h3>
          <p className="text-xl text-gray-700 mb-6" data-id="element-147">
            Es un sistema claro que te diga:
          </p>
          <ul className="space-y-4 text-xl font-medium text-gray-800 inline-block text-left" data-id="element-148">
            <li data-id="element-149">👉 qué hacer</li>
            <li data-id="element-150">👉 cómo reaccionar</li>
            <li data-id="element-151">👉 cómo mantener la calma</li>
          </ul>
        </div>

        <div className="bg-green-50 rounded-2xl p-8 md:p-10 mt-12 border border-green-100" data-id="element-152">
          <h3 className="text-2xl md:text-3xl font-bold text-green-800 mb-8 text-center" data-id="element-153">
            📘 Con el Método Calma®
          </h3>
          <p className="text-xl text-gray-800 mb-6 text-center font-medium" data-id="element-154">
            Vas a aprender a:
          </p>
          <ul className="space-y-4 text-lg md:text-xl text-gray-700 max-w-lg mx-auto" data-id="element-155">
            <li data-id="element-156">✨ Manejar situaciones difíciles sin gritar</li>
            <li data-id="element-157">💬 Comunicarte mejor con tu hijo</li>
            <li data-id="element-158">🧠 Entender lo que realmente necesita</li>
            <li data-id="element-159">💞 Crear una relación más sana y fuerte</li>
          </ul>
        </div>
      </div>
    </section>;
}